import { useOutletContext } from 'react-router-dom';

import { OutletContext } from 'types';

function useApi() {
  const { api } = useOutletContext<OutletContext>();
  return api;
}

export default useApi;
